import { render } from "./BtnRadio.vue?vue&type=template&id=37473aa0&scoped=true"
import script from "./BtnRadio.vue?vue&type=script&lang=js"
export * from "./BtnRadio.vue?vue&type=script&lang=js"

import "./BtnRadio.vue?vue&type=style&index=0&id=37473aa0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37473aa0"]])

export default __exports__